import { AppInitPhase } from './app-init.const'
import type { AppInitStoreState } from './app-init.type'

export const appInitInitialState: AppInitStoreState = {
  phase: AppInitPhase.Idle,
  hasInitialized: false,
  error: null,
  pipelineStarted: false,
}
